var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 25 20" }, props),
    React.createElement("path", { className: (styles["oc-icon-indicator"] || "oc-icon-indicator") + " " + (styles["oc-icon-status-error"] || "oc-icon-status-error"), d: "M20 9.12V5.9L14.2 0H5.9L0 5.9v8.2L5.9 20h8.2l2.9-2.85 1.68 2.91L25 9.12zM8.5 6.1a1.3 1.3 0 1 1 2.6 0v4a1.3 1.3 0 1 1-2.6 0zm2.9 8.6a1.53 1.53 0 0 1-1.7 1.5 1.53 1.53 0 0 1-1.5-1.7A1.7 1.7 0 0 1 9.7 13a1.64 1.64 0 0 1 1.7 1.5c.1.1.1.1 0 .2zm4.12-3.78h6.34l-3.17 5.5z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/indicators/ErrorSub.svg